import navBookmarkActive from '@/assets/images/icons/global-nav-bookmark-active.svg';
import navBookmark from '@/assets/images/icons/global-nav-bookmark.svg';
import navMessageActive from '@/assets/images/icons/global-nav-message-active.svg';
import navMessage from '@/assets/images/icons/global-nav-message.svg';
import navProfileActive from '@/assets/images/icons/global-nav-profile-active.svg';
import navProfile from '@/assets/images/icons/global-nav-profile.svg';
import navScoutActive from '@/assets/images/icons/global-nav-scout-active.svg';
import navScout from '@/assets/images/icons/global-nav-scout.svg';
import type { NavItem, SettingsMenuItem, SpBottomNavItem } from './types.d';

export const navItems: NavItem[] = [
  { label: 'マイページ', href: '/' },
  { label: 'プロフィール', href: '/profiles/edit' },
  {
    label: '気になる/検討中',
    children: [
      { label: '気になるリスト', href: '/favorites/received' },
      { label: '検討中リスト', href: '/agent/auth/consideration_jobs' },
    ],
  },
  {
    label: 'スカウト/おすすめ',
    children: [
      { label: '企業スカウト求人', href: '/scouts', action: 'scout' },
      {
        label: 'エージェントからのおすすめ求人',
        labelHtml: 'エージェントからの<br />おすすめ求人',
        href: '/recommended-jobs',
      },
    ],
  },
  {
    label: '選考管理',
    children: [
      { label: '企業スカウト', href: '/messages' },
      { label: 'エージェント', href: '/messages?platform=agent' },
    ],
  },
  {
    label: '求人検索',
    children: [
      { label: '企業スカウト求人', href: '/jobs?direct=true' },
      { label: 'エージェント求人', href: '/jobs?agent=true' },
    ],
  },
];

export const spBottomNavItems: SpBottomNavItem[] = [
  {
    label: 'プロフィール',
    href: '/profiles/edit',
    agentHref: '/profiles/edit',
    directHref: '/profiles/edit',
    icon: navProfile,
    iconActive: navProfileActive,
  },
  {
    label: '気になる/検討中',
    href: '/agent/auth/consideration_jobs',
    agentHref: '/agent/auth/consideration_jobs',
    directHref: '/favorites/received',
    icon: navBookmark,
    iconActive: navBookmarkActive,
  },
  {
    label: 'スカウト/おすすめ',
    href: '/recommended-jobs',
    agentHref: '/recommended-jobs',
    directHref: '/favorites/received',
    icon: navScout,
    iconActive: navScoutActive,
  },
  {
    label: '選考管理',
    href: '/messages?platform=agent',
    agentHref: '/messages?platform=agent',
    directHref: '/messages',
    icon: navMessage,
    iconActive: navMessageActive,
  },
];

export const settingsMenuItems: SettingsMenuItem[] = [
  { label: '利用サービス確認', href: '/services' },
  { label: 'メールアドレス / パスワード変更', href: '/setting/info' },
  { label: '通知 / ブロック企業設定', href: '/setting/notification' },
  { label: '内定受諾報告', href: '/offer_report' },
  { label: 'FAQ', href: '/faq' },
  { label: '利用規約', href: '/terms' },
  { label: 'ログアウト', action: 'logout' },
];

export const detectActiveNav = (pathname: string, search: string): string => {
  const cleanSearch = search || '';
  if (pathname === '/' || pathname === '/home') return 'マイページ';
  if (pathname.startsWith('/profiles')) return 'プロフィール';
  if (
    pathname.startsWith('/favorites/received') ||
    pathname.startsWith('/agent/auth/consideration_jobs')
  )
    return '気になる/検討中';
  if (
    pathname.startsWith('/favorites/received') ||
    pathname.startsWith('/recommended-jobs') ||
    pathname.startsWith('/scouts')
  )
    return 'スカウト/おすすめ';
  if (pathname.startsWith('/messages')) return '選考管理';
  if (
    (pathname.startsWith('/jobs') && cleanSearch.includes('direct=true')) ||
    (pathname.startsWith('/jobs') && cleanSearch.includes('agent=true'))
  )
    return '求人検索';
  return '';
};
